import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { SvgIconBase } from '@/components/ui/SvgIcon/SvgIconBase';
export const VariableSvgIconBase = (props) => {
    const { children, className, color, size } = props;
    return (_jsx(SvgIconBase, Object.assign({ className: className, color: color, size: size }, { children: children })));
};
